import {
	FormOutlined
} from "@ant-design/icons";
import { Form, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import { DataCourse, statusTypes } from "types";
import "react-quill/dist/quill.snow.css";
import "./style.scss";
import { AddModuleModal, EditModuleModal, MenuPage } from "components";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";

export const ManageModules: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [courseStatus, setCourseStatus] = useState<boolean>(false);
	const [currentModuleInfo, setCurrentModuleInfo] = useState<any[]>([]);
	const navigate = useNavigate();
	// @ts-ignore
	const { state }: { state: { data: DataCourse } } = useLocation();
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { module: courseModule },
			},
		} = await api.get(`/modules/${id}`);
		setCurrentModuleInfo(courseModule);
	};

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
					width: "30%",
				};
			},
		},
		{
			title: "Aulas",
			dataIndex: "classes_length",
			key: "classes_length",
			render: (length) => (
				<p style={{ margin: 0 }}>{length ? length : "-"} aulas</p>
			),
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Criado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Autor",
			dataIndex: "author",
			key: "author",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => <p style={{ margin: 0 }}>{statusTypes[status]}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/module/${data.id}`, {
							state: { data, generalState: state.data },
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.modules;
	}

	const backToModules = () => {
		navigate(`/manage-courses`, {state: {data: state.data}})
	}
	
	return (
		<div className="m-modules">
			<AddModuleModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				courseId={state?.data?.id}
				titlePage={`Curso - ${state?.data?.title}`}
				onCreated={handleRefresh}
			/>
			<EditModuleModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				courseId={state?.data?.id}
				titlePage={`Curso - ${state?.data?.title}`}
				currentModuleInfo={currentModuleInfo}
				onUpdated={handleRefresh}
			/>

			<div className="m-classes__back-action">
				<button className="m-classes__back-action__btn" 					
						onClick={backToModules}
						>Voltar a Cursos</button>
			</div>

			<MenuPage 
				title="Modulos"
				subtitle={`Módulos do curso ${state.data?.title}`}
				tableColumns={columns} 
				sourceDataUrl={`/courses/${state.data.id}/modules`}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Módulo" 
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por nome ou descrição"
			/>
		</div>
	);
};
